import { render, staticRenderFns } from "./InfoCardRow.vue?vue&type=template&id=664913e9&scoped=true&"
var script = {}
import style0 from "./InfoCardRow.vue?vue&type=style&index=0&id=664913e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664913e9",
  null
  
)

export default component.exports